import axios from 'axios'

type AxiosReportInstanceOptions = {
  checkAuthentication?: boolean,
  responseType?: 'json' | 'blob' | 'text' | 'arraybuffer' | 'document' | 'stream',
};

const createAxiosReportInstance = ({ checkAuthentication, responseType }: AxiosReportInstanceOptions) => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_REPORT_API,
    headers: {
      'Content-Type': 'application/json',
      'BancoSchema': localStorage.getItem('empresa') ? localStorage.getItem('empresa') : '',
      'UsuarioIdSchema': localStorage.getItem('idUsuario') ? localStorage.getItem('idUsuario') : ''
    },
    validateStatus: (status) => true,
    responseType: responseType ?? 'json',
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const updatedToken = localStorage.getItem('empresa')
      const usuarioId = localStorage.getItem('idUsuario')
      if (updatedToken && usuarioId) {
        config.headers.BancoSchema = updatedToken;
        config.headers.UsuarioIdSchema = usuarioId;
      }
      return config
    }
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      return error
    }
  );

  return axiosInstance;
}

export const axiosReportInstance = createAxiosReportInstance